import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={19} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M6.75 16.517h4.5c3.75 0 5.25-1.5 5.25-5.25v-4.5c0-3.75-1.5-5.25-5.25-5.25h-4.5c-3.75 0-5.25 1.5-5.25 5.25v4.5c0 3.75 1.5 5.25 5.25 5.25'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M9 11.642a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M13.227 5.267h.009'
    />
  </svg>
);
export default SvgInstagram;
